// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ru-z","tooltipWrapper":"su-z","icon":"tu-z","tooltip":"uu-z","content":"vu-z"};